module.exports = __webpack_public_path__ + "static/img/E005.9a2aa54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/E005.jpg
// module id = v1Ug
// module chunks = 1